import React from 'react';
import PropTypes from 'prop-types';
import { Box, ButtonBase, Typography } from '@mui/material';
import {
  Favorite as FavoriteIcon,
  FavoriteBorder as FavoriteBorderIcon,
  Label as LabelIcon,
  MoreVert as MoreVertIcon,
  Send as SendIcon,
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from '@mui/icons-material';

const ArticleModalMobileFooterActions = ({
  article,
  onOpenMore,
  onOpenShare,
  onOpenTagDialog,
  onToggleFavorite,
  onToggleRead,
  readOnly
}) => {
  const buttons = readOnly ? [
    {
      id: 'share',
      icon: <SendIcon sx={{ fontSize: 20 }} />,
      label: 'Enviar',
      active: false,
      color: 'primary.main',
      onClick: onOpenShare
    },
    {
      id: 'more',
      icon: <MoreVertIcon sx={{ fontSize: 20 }} />,
      label: 'Mais',
      active: false,
      color: 'primary.main',
      onClick: onOpenMore
    }
  ] : [
    {
      id: 'fav',
      icon: article.isFavorite ? <FavoriteIcon sx={{ fontSize: 20 }} /> : <FavoriteBorderIcon sx={{ fontSize: 20 }} />,
      label: 'Favorito',
      active: article.isFavorite,
      color: 'error.main',
      onClick: onToggleFavorite
    },
    {
      id: 'read',
      icon: article.isRead ? <VisibilityIcon sx={{ fontSize: 20 }} /> : <VisibilityOffIcon sx={{ fontSize: 20 }} />,
      label: article.isRead ? 'Lido' : 'Não lido',
      active: article.isRead,
      color: 'primary.main',
      onClick: onToggleRead
    },
    {
      id: 'tag',
      icon: <LabelIcon sx={{ fontSize: 20 }} />,
      label: 'Tags',
      active: false,
      color: 'primary.main',
      onClick: onOpenTagDialog
    },
    {
      id: 'share',
      icon: <SendIcon sx={{ fontSize: 20 }} />,
      label: 'Enviar',
      active: false,
      color: 'primary.main',
      onClick: onOpenShare
    },
    {
      id: 'more',
      icon: <MoreVertIcon sx={{ fontSize: 20 }} />,
      label: 'Mais',
      active: false,
      color: 'primary.main',
      onClick: onOpenMore
    }
  ];

  return (
    <Box sx={{ display: { xs: 'flex', md: 'none' }, width: '100%', alignItems: 'stretch' }}>
      {buttons.map((button) => (
        <ButtonBase
          key={button.id}
          onClick={button.onClick}
          aria-label={button.label}
          aria-pressed={button.id === 'fav' || button.id === 'read' ? button.active : undefined}
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 48,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.5,
            borderRadius: 1.5,
            py: 0.25,
            mx: 0.15,
            color: button.active ? button.color : 'text.secondary',
            bgcolor: button.active ? 'action.selected' : 'transparent',
            transition: 'color 0.15s ease, background-color 0.15s ease',
            '&:active': { bgcolor: 'action.selected', transform: 'scale(0.97)' },
            '& .MuiSvgIcon-root': { fontSize: 21 }
          }}
        >
          {button.icon}
          <Typography
            variant="caption"
            sx={{
              width: '100%',
              px: 0.25,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              textAlign: 'center',
              fontSize: '0.62rem',
              fontWeight: button.active ? 750 : 550,
              lineHeight: 1,
              letterSpacing: 0.2,
              color: 'inherit'
            }}
          >
            {button.label}
          </Typography>
        </ButtonBase>
      ))}
    </Box>
  );
};

ArticleModalMobileFooterActions.propTypes = {
  article: PropTypes.shape({
    isFavorite: PropTypes.bool,
    isRead: PropTypes.bool
  }).isRequired,
  onOpenMore: PropTypes.func.isRequired,
  onOpenShare: PropTypes.func.isRequired,
  onOpenTagDialog: PropTypes.func.isRequired,
  onToggleFavorite: PropTypes.func.isRequired,
  onToggleRead: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};

ArticleModalMobileFooterActions.defaultProps = {
  readOnly: false
};

export default ArticleModalMobileFooterActions;
